import { TableCell } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AppPopover } from "../../../../../../common/AppPopover";
import { usePopover } from "../../../../../../common/hooks/use-popover";
import { AppIconButton } from "../../../../../../shared/components/AppIconButton";
import { CopyIcon } from "../../../../../../shared/icons/CopyIcon";
import { TrashIcon } from "../../../../../../shared/icons/TrashIcon";
import { transformToken } from "../../../helpers";
import styles from "./styles.module.css";

interface Props {
  copyToken: string;
  onDelete: (id: number) => void;
}

export const StaticTokenActionsCell = (props: Props) => {
  const {
    anchorPopoverEl,
    openPopover,
    handleOpenPopover,
    handleClosePopover,
  } = usePopover();
  const { t } = useTranslation();

  return (
    <TableCell className={styles["action-cell"]}>
      <AppIconButton
        children={<CopyIcon />}
        onClick={() => navigator.clipboard.writeText(props.copyToken)}
      />
      <AppIconButton children={<TrashIcon />} onClick={handleOpenPopover} />
      <AppPopover
        open={openPopover}
        anchorEl={anchorPopoverEl}
        handleClose={handleClosePopover}
        onOk={(id: string | number | undefined) => {
          props.onDelete(id as number);
          handleClosePopover();
        }}
      >
        <div className={styles["popover-content"]}>
          {t("versioning.delete_popover")}
          <strong>{transformToken(props.copyToken)}</strong>?
        </div>
      </AppPopover>
    </TableCell>
  );
};
